import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import { banksService } from '../../_services/banks.service'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
);

class BankSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      defaultValue: '',
      data: [],
    };
  }

  componentWillMount() {
    this.getData();
  }

  getData() {
    banksService.getAll()
      .then((res) => {
        // // console.log(res.data)
        let data = res.data.map(elm => ({ "label": elm.name, "value": elm.id }))
        this.setState({ data: data, loading: false, isSubmitting: false });
      })
  };

  handleChange = e => {
    // // console.log(e);

    this.props.onChange(e);
  }

  render() {
    const customStyles = {
      // option: (provided, state) => ({
      //   ...provided,
      //
      // }),
      control: (provided) => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#f6f6f6',
        borderRadius: 20,
        // height: 40,
        boxShadow: 'none',
        border: '1px solid #e1e1e1',
        paddingRight: '12',
        // boxShadow: '0 1px 8px rgba(0, 0, 0, 0.085)',
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),

    }
    const { loading, data } = this.state;
    const { disabled, className } = this.props;

    return (
      <Select
        isClearable
        isDisabled={disabled}
        placeholder=""
        styles={customStyles}
        options={data}
        onChange={this.handleChange}
        value={this.props.defaultValue}
        className={className ? className : "select"}
        isLoading={loading}
        noOptionsMessage={() => "نتیجه ای یافت نشد"}
        loadingMessage={() => "در حال بارگزاری"}
      />
    );
  }
}
export default BankSelect;
